/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Topics_TitleInputs */



/**
* | output |
* | --- |
* | "Topics" |
*
* @param {Settings_Template_Topics_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_topics_title = /** @type {((inputs?: Settings_Template_Topics_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Topics_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Onderwerpen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sujets")
	return /** @type {LocalizedString} */ ("Topics")
});